import Box from "@mui/material/Box";
import {useTheme} from "@mui/material";
import useMediaQuery from "@mui/material/useMediaQuery";

import TenantInfo from "app/sidebar/TenantInfo";
import UserInfo from "app/sidebar/UserInfo";
// import Search from "components/sidebar/Search";
import Menu from "app/sidebar/Menu";
import MenuMobile from "app/sidebar/MenuMobile";
import BrioLogoFooter from "app/sidebar/BrioLogoFooter";
// import { useAuth } from "hooks/useAuth";
import useSticky from "hooks/useStiky";
import React from "react";
import {Link} from "react-router-dom";
import NotificationsIcon from "../../features/notifications/components/NotificationsIcon";
import {useAuth} from "../../hooks/useAuth";
// import {useAuth} from "../../hooks/useAuth";

const Sidebar = ({layoutPublic = false, bgImage = false}: { layoutPublic?: boolean, bgImage?: boolean }) => {
    const { user } = useAuth();
    const {stickyRef, sticky} = useSticky();
    // const { tenant } = useAuth();

    const theme = useTheme();
    const isLgUp = useMediaQuery(theme.breakpoints.up("lg"));

    return (
        <>
            {layoutPublic ? (
                <>
                    {/* <Box sx={{ position: "relative", bottom: -9, right: -8, display: { xs: "none", md: "block" } }}>
                        <ThemeToggle />
                      </Box> */}
                    <Box
                        position="relative"
                        display="flex"
                        flexDirection="column"
                        alignItems="flex-start"
                        justifyContent="content-between"
                        sx={(theme) => ({
                            paddingTop: 0,
                            height: "auto",
                        })}
                    >
                        {/* <Box sx={{ position: "absolute", top: "11px", right: "13px", display: { xs: "block", md: "none" } }}>
                            <ThemeToggle />
                          </Box> */}
                        <Box width="100%">
                            <Box
                                py={1.5}
                                display="flex"
                                justifyContent="space-between"
                                alignItems="center"
                                ref={stickyRef}
                                sx={(theme) => ({
                                    width: "100%",
                                    zIndex: 1,
                                    backgroundColor: "background.paper",
                                    position: {xs: "fixed", lg: "relative"},
                                    top: 0,
                                    borderRadius: { xs: 0, lg: theme.spacing(3, 3, 0, 0)},
                                    boxShadow: bgImage ? "none" : "0px 2px 3px 0px #c6d2e5",
                                })}
                            >
                                <Box ml={{xs: 1, md: 2, lg: 4}}>
                                    <BrioLogoFooter/>
                                </Box>
                                <Box mr={{xs: 0, md: 2, lg: 4}}>
                                    <MenuMobile/>
                                </Box>
                            </Box>
                            {isLgUp ? (
                                <></>
                            ) : (
                                <div
                                    style={{
                                        height: `${stickyRef.current?.clientHeight}px`
                                    }}
                                />
                            )}
                        </Box>
                    </Box>
                </>
            ) : (
                <Box
                    position="relative"
                    display="flex"
                    maxHeight="100dvh"
                    flexDirection="column"
                    alignItems="flex-start"
                    justifyContent="content-between"
                    sx={(theme) => ({
                        paddingTop: {xs: 0, lg: 3},
                        height: {xs: "auto", lg: "100dvh"},
                    })}
                >
                    {isLgUp ? (
                        <>
                            <Box width="100%" sx={{paddingRight: {xs: 0, lg: 2, xl: 3}}}>
                                <TenantInfo/>
                                <Box
                                    display={{xs: "block", sm: "flex"}}
                                    alignItems="center"
                                    justifyContent="space-between"
                                     sx={{marginBottom: {xs: 0, lg: 3}}}
                                >
                                <Link to="/profil"><UserInfo/></Link>
                                    {user.tenantNotifications && (
                                        <Box sx={{display: {xs: "none", lg: "block"}}}>
                                            <NotificationsIcon/>
                                        </Box>
                                    )}
                                </Box>
                            </Box>
                            <Box width="100%" flexGrow={1}
                                 sx={{overflow: "hidden", paddingRight: {xs: 0, lg: 1, xl: 3}}}>
                                <Menu/>
                            </Box>
                            <Box width="100%" pl={3} pt={3} pb={2}>
                                <BrioLogoFooter/>
                            </Box>
                        </>
                    ) : (
                        <Box width="100%">
                            <TenantInfo/>
                            <Box
                                py={1.5}
                                display="flex"
                                justifyContent="space-between"
                                alignItems="center"
                                ref={stickyRef}
                                sx={{
                                    width: "100%",
                                    zIndex: 1,
                                    backgroundColor: "background.paper",
                                    position: sticky ? "fixed" : "relative",
                                    top: 0,
                                }}
                            >
                                <Link to="/profil"><UserInfo/></Link>
                                <Box>
                                    <MenuMobile/>
                                </Box>
                            </Box>
                            <div
                                style={{
                                    height: sticky ? `${stickyRef.current?.clientHeight}px` : "0px",
                                }}
                            />
                        </Box>
                    )}
                </Box>
            )}
        </>

    );
};

export default Sidebar;
